export default {
	addressTile: {
		deliveryNotificationPhone: "Avviso di consegna: {phone}",
		invoiceSentVia: "La fattura viene inviata per {method}",
		invoiceMethodEmail: "E-mail",
		invoiceMethodPost: "Posta",
		applyAddressButton: "Usa",
		preferredTooltipAlreadySet:
			"Questo indirizzo è già contrassegnato come preferito e verrà preselezionato per i suoi ordini.",
		preferredTooltipSetAsFavorite:
			"Contrassegni come preferito. Questo indirizzo verrà preselezionato per i suoi ordini.",
		editAddressTooltip: "Modifica indirizzo",
		editPermissionMissingTooltip: "Autorizzazione a modificare l'indirizzo non presente",
		deleteAddressTooltip: "Elimina indirizzo",
		deletePermissionMissingTooltip: "Autorizzazione a eliminare l'indirizzo non presente",
		deleteAddressDialog: {
			title: "Elimina indirizzo",
			text: "È sicuro di voler eliminare questo indirizzo?",
			deleteButtonTooltip: "Elimina definitivamente l'indirizzo.",
			deleteButton: "Elimina",
		},
	},
	addressesOverview: {
		createAddressButton: "Crea nuovo indirizzo",
	},
	changeAddress: {
		newAddressTitle: "Crea nuovo indirizzo",
		editAddressTitle: "Modifica indirizzo",
		firstNameLabel: "Nome",
		lastNameLabel: "Cognome",
		companyLabel: "Azienda",
		streetLabel: "Via / N.",
		zipLabel: "CAP",
		townLabel: "Località",
		countryHint: "Il paese non può essere modificato. La preghiamo di contattarci all'indirizzo info@blexon.com",
		deliveryPhoneLabel: "Numero di telefono per l'avviso di consegna",
		invoiceEmailLabel: "Indirizzo e-mail per l'invio della fattura",
		invoiceByEmailLabel: "Fattura per e-mail",
		invoiceByPostLabel: "Fattura per posta",
		shippingMethodLockedText: "Per questo ordine non è più possibile modificare la modalità di spedizione.",
		saveButtonTooltip: "Salva le modifiche.",
		invalidZipMessage: "Deve essere un CAP valido.",
		messages: {
			saveSuccess: "Indirizzo salvato con successo.",
			saveError: "Non è stato possibile salvare l'indirizzo.",
		},
	},
	customerSettings: {
		customerNumberLabel: "Il suo numero cliente",
		customerNumberHint: "Questo numero è assegnato in modo fisso e non può essere modificato.",
		personalAccountLabel: "Conto personale / privato",
		companyNameLabel: "Nome azienda",
		vatNumberLabel: "Numero IVA / Partita IVA",
		useCompanyAccountLabel: "Usa come conto aziendale",
		streetLabel: "Via / N.",
		zipLabel: "CAP",
		townLabel: "Località",
		countryLabel: "Paese",
		generalPhoneLabel: "Telefono (generale)",
		accountEmailLabel: "E-mail del conto cliente",
		accountEmailHint: "Questo indirizzo viene utilizzato in alternativa all'e-mail dell'utente.",
		defaultOrderNotificationEmailLabel: "E-mail predefinita per notifiche d'ordine aggiuntive",
		defaultOrderNotificationEmailHint:
			"Nel processo d'ordine è possibile indicare un indirizzo e‑mail aggiuntivo, che verrà anch'esso informato sull'ordine. Se nel campo sopra viene indicato un indirizzo e‑mail, questo verrà utilizzato come indirizzo predefinito e compilato automaticamente.",
		correspondenceLanguageLabel: "Lingua di corrispondenza",
		correspondenceLanguageHint:
			"In questa lingua vengono creati tutti i documenti come conferme d'ordine e fatture, nonché tutte le e‑mail a lei destinate.",
		requiredMessage: "Indicazione richiesta",
		whitespaceOnlyMessage: "L'inserimento non può contenere solo spazi.",
		maxLength50Message: "Sono consentiti al massimo 50 caratteri.",
		companyNamePrivateMessage: "Il nome dell'azienda non può essere 'privat'.",
		invalidZipMessage: "Deve essere un CAP valido.",
		messages: {
			saveSuccess: "Impostazioni salvate con successo.",
			saveError: "Non è stato possibile salvare le impostazioni.",
		},
	},
	userManagement: {
		addUserButton: "Aggiungi utente",
		emailChangeHint:
			"Nota: per modificare l'indirizzo e-mail dell'utente attuale, utilizzi la funzione nelle {userSettingsLink}.",
		userSettingsLinkText: "impostazioni utente",
		pendingConfirmationTooltip: "Conferma dell'utente invitato ancora in sospeso.",
		contextMenuTooltip: "Apre il menu contestuale dell'utente.",
		deleteMenuItem: "Elimina",
		manageUsersLabel: "Gestisci utenti",
		orderDirectlyLabel: "Ordina",
		orderIndirectlyLabel: "Richiedi ordine",
		changeDeliveryAddressLabel: "Modifica indirizzi di consegna",
		changeInvoiceAddressLabel: "Modifica indirizzi di fatturazione",
		ownUserRightsTooltip: "I diritti del proprio utente non possono essere modificati.",
		unconfirmedUserRightsTooltip: "I diritti possono essere modificati solo quando l'utente è confermato.",
		manageUsersMinimumTooltip: 'Almeno 1 utente deve sempre avere il diritto "Gestisci utenti".',
		manageUsersDescriptionTooltip:
			"L'utente può aggiungere altri utenti, eliminare utenti e modificare i diritti di tutti gli utenti.",
		orderDirectlyMinimumTooltip: 'Almeno 1 utente deve sempre avere il diritto "Ordina".',
		orderDirectlyDescriptionTooltip: "L'utente può effettuare ordini a pagamento.",
		orderIndirectlyDescriptionTooltip:
			"L'utente può preparare ordini e inviarli per conferma a un utente con l'autorizzazione corrispondente.",
		changeDeliveryAddressDescriptionTooltip: "L'utente può modificare gli indirizzi di consegna.",
		changeInvoiceAddressDescriptionTooltip: "L'utente può modificare gli indirizzi di fatturazione.",
		noPermissionText: "Autorizzazione per la gestione utenti non presente.",
		addUserDialogTitle: "Aggiungi utente",
		newUserEmailPlaceholder: "E-mail del nuovo utente",
		newUserRightsLabel: "Diritti del nuovo utente",
		addButton: "Aggiungi",
		deleteUserDialog: {
			title: "È sicuro?",
			text: "Vuole davvero rimuovere l'utente {username} dal conto?",
			confirmButton: "Rimuovi",
		},
		messages: {
			loadUserIdError: "Errore durante il caricamento dell'ID utente.",
			loadUsersError: "Errore durante il caricamento degli utenti.",
			saveClaimSuccess: "Autorizzazione salvata con successo.",
			saveClaimError: "Errore durante il salvataggio dell'autorizzazione.",
			inviteSuccess: "Invito inviato con successo all'utente.",
			inviteError: "Errore durante l'invio dell'invito all'utente.",
			removeUserError: "Errore durante l'eliminazione dell'utente.",
		},
	},
};
